import type { VolumeOfferContent } from '../domain/landing.types'

type VolumeSectionProps = {
  content: VolumeOfferContent
}

export function VolumeSection({ content }: VolumeSectionProps) {
  return (
    <section className="volume-section" aria-labelledby="volume-title">
      <div className="volume-section__hero">
        <p>{content.eyebrow}</p>
        <h2 id="volume-title">{content.title}</h2>
        <span>{content.description}</span>
      </div>

      <div className="volume-section__relationship-heading">
        <p>Dos formas de comprar</p>
        <h3>{content.relationshipTitle}</h3>
      </div>

      <ol className="volume-section__modes" aria-label="Modalidades de compra">
        {content.modes.map((mode) => (
          <li key={mode.order}>
            <span>{String(mode.order).padStart(2, '0')}</span>
            <div>
              <h4>{mode.title}</h4>
              <p>{mode.description}</p>
            </div>
          </li>
        ))}
      </ol>

      <div className="volume-section__cta volume-section__cta--minimal">
        <a className="button button--light" href="#cotizar">Solicitar cotización</a>
      </div>
    </section>
  )
}
